const TEAM_SENDER_PREFIXES = new Set(['dr', 'doctor', 'mr', 'mrs', 'ms', 'miss'])
const TEAM_SENDER_SUFFIXES = new Set(['md', 'do', 'np', 'pa', 'pa-c', 'rn', 'fnp', 'aprn', 'pharmd', 'jr', 'sr', 'ii', 'iii', 'iv'])

function formatTeamSenderToken(value = '') {
  const token = String(value || '').trim()
  if (!token) return ''
  if (/^[A-Z]{2,}$/.test(token)) return token
  return `${token.charAt(0).toUpperCase()}${token.slice(1).toLowerCase()}`
}

export function teamSenderShortName(value, fallback = 'KIS Rx Support') {
  const raw = String(value || '').trim()
  if (!raw) return fallback
  if (/^(kis\s+rx\s+)?support(\s+team)?$/i.test(raw) || /^(support\s+team|coach|patient)$/i.test(raw)) return raw
  const emailName = raw.includes('@') && !raw.includes(' ') ? raw.split('@')[0] : raw
  const parts = emailName
    .replace(/[(),]/g, ' ')
    .split(/\s+/)
    .map(part => part.replace(/^[^a-z0-9]+|[^a-z0-9-]+$/gi, ''))
    .filter(Boolean)
  while (parts.length && TEAM_SENDER_PREFIXES.has(parts[0].toLowerCase().replace(/\.$/, ''))) parts.shift()
  while (parts.length > 1 && TEAM_SENDER_SUFFIXES.has(parts[parts.length - 1].toLowerCase().replace(/\.$/, ''))) parts.pop()
  if (!parts.length) return fallback
  const first = formatTeamSenderToken(parts[0])
  if (parts.length === 1) return first
  const last = formatTeamSenderToken(parts[parts.length - 1])
  return `${first} ${last.charAt(0).toUpperCase()}.`
}
